import React from 'react';

export const Footer = ({ t, scrollToSection }) => {
  return (
    <footer className="bg-gray-900 text-white py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_file-based-website-1/artifacts/r5rhhf4l_Anlumax-Logos-New-Palette_White.png"
              alt="AnluMAX Logo"
              className="h-10 mb-4"
              loading="lazy"
              data-testid="footer-logo"
            />
            <p className="text-gray-400" data-testid="footer-tagline">{t.footer.tagline}</p>
          </div>
          <div>
            <h4 className="font-semibold mb-4" data-testid="footer-quick-links-title">{t.footer.quickLinks}</h4>
            <div className="space-y-2">
              <button onClick={() => scrollToSection('about')} className="block text-gray-400 hover:text-blue-400 transition-colors">{t.nav.about}</button>
              <button onClick={() => scrollToSection('industries')} className="block text-gray-400 hover:text-blue-400 transition-colors">{t.nav.industries}</button>
              <button onClick={() => scrollToSection('standards')} className="block text-gray-400 hover:text-blue-400 transition-colors">{t.nav.standards}</button>
              <button onClick={() => scrollToSection('safety')} className="block text-gray-400 hover:text-blue-400 transition-colors">{t.nav.safety}</button>
            </div>
          </div>
          <div>
            <h4 className="font-semibold mb-4" data-testid="footer-contact-title">{t.footer.contact}</h4>
            <div className="space-y-2 text-gray-400">
              <p data-testid="footer-phone">+27 11 712 0000</p>
              <p data-testid="footer-email">info@anlumax.co.za</p>
              <p data-testid="footer-website">www.anlumax.co.za</p>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
          <p data-testid="footer-copyright">&copy; {new Date().getFullYear()} AnluMAX (Pty) Ltd. {t.footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
};
